import { signUpFormActions } from '../actions/SignUpFormActions';

export type SignUpFormState = {
  email?: string | null;
};

const initialState: SignUpFormState = {};

export default function signUpForm(state = initialState, action: any) {
  switch (action.type) {
    case signUpFormActions.setEmailAction:
      return { ...state, email: action.payload };
    case signUpFormActions.resetAction:
      return { ...initialState };
    default:
      return state;
  }
}
